import React from 'react';
import styled from '@emotion/styled';

import { DocumentPath } from '../../../types';
import { ImageMapLinkEditor } from '../ImageMapLink/ImageMapLinkEditor';
import { ImageMapBrazeButton, ImageMapBrazeButtonProps } from './ImageMapBrazeButton';

export interface ImageMapBrazeProps extends ImageMapBrazeButtonProps {
  path: DocumentPath;
}

export function ImageMapBraze({
  children,
  path,
  ...rest
}: React.PropsWithChildren<ImageMapBrazeProps>) {
  return (
    <ImageMapLinkEditor path={path}>
      <StyledButton {...rest}>
        { children || '' }
      </StyledButton>
    </ImageMapLinkEditor>
  );
}

const StyledButton = styled(ImageMapBrazeButton)`
  position: absolute;
`;
